<template>
    <Card class="tw-mb-4 tw-shadow-md">
        <p slot="title" class="tw-flex tw-items-center tw-gap-2">
            <Icon type="ios-funnel" size="18" />
            <span class="tw-font-semibold">Filter & Actions</span>
        </p>
        <Row :gutter="16" type="flex" align="bottom">
            <Col span="5">
                <div class="tw-mb-2">
                    <label class="tw-block tw-text-sm tw-font-medium tw-text-gray-700 tw-mb-1">
                        <Icon type="ios-calendar" class="tw-mr-1" />Transaction Date
                    </label>
                    <DatePicker 
                        v-model="localDate" 
                        type="date" 
                        format="dd-MM-yyyy" 
                        placeholder="Select date" 
                        style="width: 100%" 
                        @on-change="handleDateChange" 
                        size="large"
                    />
                </div>
            </Col>
            <Col span="5">
                <div class="tw-mb-2">
                    <label class="tw-block tw-text-sm tw-font-medium tw-text-gray-700 tw-mb-1">
                        <Icon type="ios-business" class="tw-mr-1" />Filter by Branch
                    </label>
                    <Select 
                        v-model="localBranch" 
                        placeholder="All Branches" 
                        clearable 
                        @on-change="handleBranchChange" 
                        size="large"
                    >
                        <Option v-for="branch in branches" :key="branch" :value="branch">{{ branch }}</Option>
                    </Select>
                </div>
            </Col>
            <Col span="6">
                <div class="tw-mb-2">
                    <label class="tw-block tw-text-sm tw-font-medium tw-text-gray-700 tw-mb-1">
                        <Icon type="ios-person" class="tw-mr-1" />Search CO Name
                    </label>
                    <Input 
                        v-model="localCoName" 
                        placeholder="Enter CO name..." 
                        clearable 
                        @on-change="handleCoNameChange" 
                        size="large"
                    >
                        <Icon type="ios-search" slot="prefix" />
                    </Input>
                </div>
            </Col>
            <Col span="8">
                <div class="tw-flex tw-gap-2 tw-mb-2">
                    <Button 
                        type="primary" 
                        icon="ios-refresh" 
                        @click="$emit('refresh')" 
                        :loading="loading" 
                        size="large"
                    >
                        Refresh
                    </Button>
                    <!-- <Button 
                        type="success" 
                        icon="md-checkmark-circle-outline" 
                        @click="$emit('clear-all-cash')" 
                        :disabled="!hasCashToClear" 
                        size="large"
                    >
                        Clear All Cash
                    </Button> -->
                    <Button 
                        icon="md-arrow-back" 
                        @click="$emit('go-back')" 
                        size="large"
                    >
                        Back
                    </Button>
                </div>
            </Col>
        </Row>
    </Card>
</template>

<script>
export default {
    name: 'FilterToolbar',
    props: {
        selectedDate: {
            type: String,
            required: true
        },
        branches: {
            type: Array,
            default: () => []
        },
        branch: {
            type: String,
            default: null
        },
        coName: {
            type: String,
            default: ''
        },
        loading: {
            type: Boolean,
            default: false
        },
        hasCashToClear: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localDate: this.selectedDate,
            localBranch: this.branch,
            localCoName: this.coName
        };
    },
    watch: {
        selectedDate(val) {
            this.localDate = val;
        },
        branch(val) {
            this.localBranch = val;
        },
        coName(val) {
            this.localCoName = val;
        }
    },
    methods: {
        handleDateChange(date) {
            this.$emit('update:selectedDate', date);
            this.$emit('date-change', date);
        },
        handleBranchChange(value) {
            this.$emit('update:branch', value);
            this.$emit('branch-change', value);
        },
        handleCoNameChange(value) {
            this.$emit('update:coName', value);
            this.$emit('co-name-change', value);
        }
    }
};
</script>
